@if (text === 'n. def.') {
  <i>
    &#91;{{ text }}&#093;
</i>
} @else {
  <span [innerHTML]="text| truncate: lengthLimit"></span>
}
